import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-copy',
  templateUrl: './copy.component.html',
  styleUrls: ['./copy.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyIconComponent {}
